import React, { useEffect, useState } from 'react';
import { Box, makeStyles } from '@material-ui/core';
import { MultiSelectCustom } from '../Shared';
import { useDispatch, useSelector } from 'react-redux';
import { manageUsersActions } from "./../../actions"
import { useTranslation } from 'react-i18next';
import { infraStructureActions } from './../../actions';


const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
  },
  containerSelect: {
    display: 'flex',
    alignItems: 'center',
  },
  view: {
    color: '#6D6D6D',
    marginRight: 10,
    fontSize: 12,
  },
}));

function TypeFilter() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const filters = [
    {
      id: '001',
      type: 'local',
      description: 'local',
    },
    {
      id: '002',
      type: 'occupationArea',
      description: 'área de ocupação',
    },
    {
      id: '003',
      type: 'businessUnit',
      description: 'unidade de negócio'
    }]

  const { filters: { types } } = useSelector(state => state.infraStructure);;

  function changeFilter(value) {
    dispatch(infraStructureActions.setFilters(value));
  };

  return (
    <Box className={classes.root}>
      <Box className={classes.containerSelect}>
        <Box className={classes.view}>{t('visualizar')}:</Box>
        {filters.length > 0 && (
          <MultiSelectCustom
            filters={filters.map(item => ({ id: item.id, value: item.type, name: item.description }))}
            statusCode={types}
            changeFilter={changeFilter}
          />
        )}
      </Box>
    </Box>
  );
}

export { TypeFilter };
